import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {MilestonePickerMilestone} from '../components/ItemPickerMilestoneRelay'
import type {
  updateIssueMilestoneRelayMutation,
  updateIssueMilestoneRelayMutation$data,
} from './__generated__/updateIssueMilestoneRelayMutation.graphql'

export function commitUpdateIssueMilestoneMutation({
  environment,
  input: {issueId, milestone},
  onError,
  onCompleted,
}: {
  environment: Environment
  input: {issueId: string; milestone: MilestonePickerMilestone | null}
  onError?: (error: Error) => void
  onCompleted?: (response: updateIssueMilestoneRelayMutation$data) => void
}) {
  return commitMutation<updateIssueMilestoneRelayMutation>(environment, {
    mutation: graphql`
      mutation updateIssueMilestoneRelayMutation($input: UpdateIssueInput!) @raw_response_type {
        updateIssue(input: $input) {
          issue {
            id
            milestone {
              ...ItemPickerMilestoneRelayMilestone
            }
          }
        }
      }
    `,
    variables: {input: {id: issueId, milestoneId: milestone ? milestone.id : null}},
    optimisticResponse: {
      updateIssue: {
        issue: {
          id: issueId,
          milestone: milestone
            ? {
                id: milestone.id,
                title: milestone.title,
                closed: milestone.closed,
                dueOn: milestone.dueOn,
                progressPercentage: milestone.progressPercentage,
                url: milestone.url,
                closedAt: milestone.closedAt,
              }
            : null,
        },
      },
    },
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}
